export const handleDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', index);
    e.dataTransfer.effectAllowed = 'move';
};

export const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
};

export const handleDrop = (e, dropIndex, editors, setEditors) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData('text/plain'));
    if (dragIndex === dropIndex) return;
    
    const newEditors = [...editors];
    const [removed] = newEditors.splice(dragIndex, 1);
    newEditors.splice(dropIndex, 0, removed);
    setEditors(newEditors);
};